// @ts-ignore
import fitty from 'fitty';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import bgImg from '../assets/images/bg-guide01.png';
import contractTitleImg from '../assets/images/03contract-title.png';

import contractLevel0Img from '../assets/images/03contract-contract-level0.png';
import contractLevel1Img from '../assets/images/03contract-contract-level1.png';
import contractLevel2Img from '../assets/images/03contract-contract-level2.png';
import contractLevel3Img from '../assets/images/03contract-contract-level3.png';
import contractLevel4Img from '../assets/images/03contract-contract-level4.png';
import contractLevel5Img from '../assets/images/03contract-contract-level5.png';
import contractLevel6Img from '../assets/images/03contract-contract-level6.png';

// cardStage 3 배후성별 개별 이미지들
import contractOlympusImg from '../assets/images/03contract-contract-올림푸스.png';
import contractHaesangImg from '../assets/images/03contract-contract-해상전신.png';
import contractGangcheolImg from '../assets/images/03contract-contract-강철의주인.png';
import contractAkmaImg from '../assets/images/03contract-contract-악마같은불의심판자.png';
import contractMujeogangImg from '../assets/images/03contract-contract-무저갱의지배자.png';
import contractDefenseImg from '../assets/images/03contract-contract-디펜스마스터.png';
import contractGuamImg from '../assets/images/03contract-contract-구암신의.png';
import contractSpringQueenImg from '../assets/images/03contract-contract-가장어두운봄의여왕.png';
import contractGingoaImg from '../assets/images/03contract-contract-긴고아의죄수.png';
import confirmTextImg from '../assets/images/03contract-confirm-txt.png';
import cancelBtnImg from '../assets/images/03contract-no.png';
import okBtnImg from '../assets/images/03contract-yes.png';
import saveBtnImg from '../assets/images/03contract-save-btn.png';
import savedTextImg from '../assets/images/03contract-saved-txt.png';
import iosTextImg from '../assets/images/03contract-ios-txt.png';
import cancelPopImg from '../assets/images/03contract-cancle-pop.png';
import cancelBtnImg2 from '../assets/images/03contract-cancle-btn.png';
import registerOkBtnImg from '../assets/images/02register-ok-btn.png';
import confirmPopImg from '../assets/images/03contract-confirm-pop.png';
import endingPopOkImg from '../assets/images/ending-pop-ok.png';
import captureLogoImg from '../assets/images/03contract-capture-logo.png';
import taleConfirmBtnImg from '../assets/images/05tale-confirm-btn.png';

import closeBtnImg from '../assets/images/03contract-close-btn.png';
import { useLocation } from 'react-router-dom';
// @ts-ignore
import html2canvas from 'html2canvas';
import { withUrlValidation } from '../components/withUrlValidation';
import { useSessionNavigation } from '../hooks/useSessionNavigation';
import { soundManager } from '../utils/soundUtils';
import BluePopup from '../components/BluePopup';
import FirebaseErrorPopup from '../components/FirebaseErrorPopup';
import { useFirebaseError } from '../hooks/useFirebaseError';
import { doc, updateDoc, arrayUnion, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { getUserFromTimeBasedCollection } from '../utils/firebaseUtils';

const FadeInBackground = styled.div<{ visible: number }>`
  width: 100dvw;
  height: 100dvh;
  min-height: 100dvh;
  background: url(${bgImg}) center/cover no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  opacity: ${({ visible }) => visible};
  transition: opacity 1.5s ease;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
`;

const ContractImageWrapper = styled.div<{ visible: number }>`
  position: relative;
  width: 95dvw;
  max-width: 95dvw;
  aspect-ratio: 43/65;
  margin-top: -5dvw;
  opacity: ${({ visible }) => visible};
  transform: translateY(${({ visible }) => visible ? '0' : '40px'});
  transition: opacity 1.2s cubic-bezier(0.4,0,0.2,1), transform 1.2s cubic-bezier(0.4,0,0.2,1);
`;

const ContractImg = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  border-radius: 0.5dvw;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
  pointer-events: none;
`;

const OverlayText = styled.span<{ top: number; left?: number; fontSize?: string; color?: string; fontFamily?: string; fontWeight?: string }>`
  position: absolute;
  top: ${({ top }) => top}%;
  left: ${({ left }) => left ?? 50}%;
  transform: translate(-50%, -50%);
  font-size: ${({ fontSize }) => fontSize ?? '3.5dvw'};
  color: ${({ color }) => color ?? '#fff'};
  font-weight: ${({ fontWeight }) => fontWeight ?? 'bold'};
  white-space: nowrap;
  pointer-events: none;
  font-family: ${({ fontFamily }) => fontFamily ?? 'MapoDPP, sans-serif'};
`;

const OverlayTextBox = styled.div`
  position: absolute;
  top: 44%;
  left: 50%;
  width: 80dvw;
  height: 3.2dvw;
  font-size: 5dvw;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: 'MapoDPP', sans-serif;
  color: #fff;
`;

const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 2dvw;
  margin-top: 3dvh;
`;

const CancelButton = styled.img`
  width: 42dvw;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover { transform: scale(1.05); }
  &:active { transform: scale(0.95); }
`;

const OkButton = styled.img`
  width: 42dvw;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover { transform: scale(1.05); }
  &:active { transform: scale(0.95); }
`;


// 아이폰용 오버레이 및 요소들 스타일 컴포넌트
const IosOverlay = styled.div.withConfig({
  shouldForwardProp: (prop) => !['visible'].includes(prop)
})<{ visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 7dvh;
  z-index: 1000;
  opacity: ${({ visible }) => visible ? 1 : 0};
  visibility: ${({ visible }) => visible ? 'visible' : 'hidden'};
  transition: opacity 0.3s ease, visibility 0.3s ease;
  touch-action: pan-y; /* 세로 스크롤만 허용, 가로 스크롤 방지 */
  overflow-y: auto; /* 세로 스크롤 허용 */
  overflow-x: hidden; /* 가로 스크롤 방지 */
  -webkit-overflow-scrolling: touch; /* iOS 스크롤 동작 제어 */
  -webkit-user-select: none; /* 텍스트 선택 방지 */
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  /* iOS 스크롤 문제 해결을 위한 추가 속성 */
  overscroll-behavior: contain; /* 스크롤 체이닝 방지 */
  -webkit-transform: translateZ(0); /* 하드웨어 가속 활성화 */
  transform: translateZ(0);
`;

const IosContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3dvh;
  padding: 4dvw;
  max-width: 90dvw;
  max-height: 100dvh;
  overflow-y: auto;
  position: relative;
`;

const CloseButton = styled.img`
  width: 6dvw;
  height: 6dvw;
  margin-right: 5dvw;
  cursor: pointer;
  transition: all 0.2s ease;
  align-self: flex-end;
  margin-bottom: 0px;
  
  &:hover {
    transform: scale(1.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const CapturedImage = styled.img`
  width: 80dvw;
  max-width: 75dvw;
  height: auto;
  border-radius: 1dvw;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
`;

const IosTextImage = styled.img`
  width: 80dvw;
  max-width: 400px;
  height: auto;
`;

// 취소 확인 팝업 관련 스타일 컴포넌트
const CancelPopupOverlay = styled.div.withConfig({
  shouldForwardProp: (prop) => !['visible'].includes(prop)
})<{ visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  opacity: ${({ visible }) => visible ? 1 : 0};
  visibility: ${({ visible }) => visible ? 'visible' : 'hidden'};
  transition: opacity 0.3s ease, visibility 0.3s ease;
`;

const CancelPopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3dvh;
  padding: 4dvw;
  max-width: 90dvw;
`;

const CancelPopupImage = styled.img`
  width: 95dvw;
  height: auto;
`;

const CancelPopupButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 2dvw;
`;

const CancelPopupNoButton = styled.img`
  width: 40dvw;
  max-width: 45dvw;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover { transform: scale(1.05); }
  &:active { transform: scale(0.95); }
`;

const CancelPopupYesButton = styled.img`
  width: 40dvw;
  max-width: 45dvw;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover { transform: scale(1.05); }
  &:active { transform: scale(0.95); }
`;

// 계약 완료 확인 팝업 관련 스타일 컴포넌트
const ConfirmPopupOverlay = styled.div.withConfig({
  shouldForwardProp: (prop) => !['visible'].includes(prop)
})<{ visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  opacity: ${({ visible }) => visible ? 1 : 0};
  visibility: ${({ visible }) => visible ? 'visible' : 'hidden'};
  transition: opacity 0.5s ease, visibility 0.5s ease;
`;

const ConfirmPopupImage = styled.img`
  width: 90dvw;
  max-width: 400px;
  height: auto;
`;

const EndingOkButton = styled.img`
  width: 80dvw;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover { transform: scale(1.05); }
  &:active { transform: scale(0.95); }
`;

// 계약 저장 팝업 관련 스타일 컴포넌트
const ContractSavePopupOverlay = styled.div.withConfig({
  shouldForwardProp: (prop) => !['visible'].includes(prop)
})<{ visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  background: #000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  opacity: ${({ visible }) => visible ? 1 : 0};
  visibility: ${({ visible }) => visible ? 'visible' : 'hidden'};
  transition: opacity 0.5s ease, visibility 0.5s ease;
`;

const ContractSavePopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100dvw;
  height: 100dvh;
  position: relative;
  padding: 5dvh 0;
  box-sizing: border-box;
  touch-action: manipulation;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
`;

const CompositeImage = styled.img`
  width: 100dvw;
  height: 100dvh;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  -webkit-tap-highlight-color: transparent;
  pointer-events: auto;
  touch-action: manipulation;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-touch-callout: default;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
  max-width: 100%;
  max-height: 100%;
  overflow: hidden;
`;

const SavePopupTopText = styled.img`
  width: 80dvw;
  top : -5%;
  max-width: 400px;
  height: auto;
  z-index: 2;
  position: relative;
`;

const SavePopupBottomText = styled.img`
  width: 80dvw;
  max-width: 400px;
  height: auto;
  margin-top: 2dvh;
`;

const SaveConfirmButton = styled.img.withConfig({
  shouldForwardProp: (prop) => !['visible'].includes(prop)
})<{ visible: boolean }>`
  width: 80dvw;
  bottom : -3%;
  max-width: 300px;
  cursor: pointer;
  transition: all 0.3s ease;
  opacity: ${({ visible }) => visible ? 1 : 0};
  transform: ${({ visible }) => visible ? 'translateY(0)' : 'translateY(20px)'};
  transition: opacity 0.5s ease, transform 0.5s ease;
  z-index: 2;
  position: relative;
  &:hover { transform: ${({ visible }) => visible ? 'scale(1.05) translateY(0)' : 'translateY(20px)'}; }
  &:active { transform: ${({ visible }) => visible ? 'scale(0.95) translateY(0)' : 'translateY(20px)'}; }
`;


const FittedText = ({ children, textShadowColor, ...props }: { children: React.ReactNode; textShadowColor?: string; minSize?: number; maxSize?: number }) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current) {
      const fit = fitty(ref.current, { minSize: 12, maxSize: 40, ...props });
      return () => fit.unsubscribe();
    }
  }, [children, props]);
  return <div ref={ref} style={{ width: '100%', height: '100%', textAlign: 'center', fontFamily: 'MapoDPP, sans-serif', color: '#fff', textShadow: `0 2px 8px rgba(255, 255, 255, 0), 0 0 5px ${textShadowColor || 'rgba(0,106,236,0.8)'}, 0 0 10px ${textShadowColor || 'rgba(0,106,236,0.6)'}, 0 0 10px ${textShadowColor || 'rgba(0,106,236,0.4)'}, 0 0 80px ${textShadowColor || 'rgba(0,106,236,0.2)'}` }}>{children}</div>;
};

const getToday = () => {
  const d = new Date();
  return `${d.getFullYear()}.${(d.getMonth()+1).toString().padStart(2, '0')}.${d.getDate().toString().padStart(2, '0')}`;
};

// 배후성 데이터와 카드 단계 매핑
const tier1Backgrounds = [
  { name: "은밀한 모략가", cardStage: 4 },
  { name: "구원의 마왕", cardStage: 5 },
  { name: "심연의 흑염룡", cardStage: 6 },
  { name: "올림푸스", cardStage: 3 },
  { name: "해상전신", cardStage: 3 },
  { name: "강철의 주인", cardStage: 3 },
  { name: "악마같은 불의 심판자", cardStage: 3 },
  { name: "무저갱의 지배자", cardStage: 3 },
  { name: "디펜스 마스터", cardStage: 3 },
  { name: "긴고아의 죄수", cardStage: 3 },
  { name: "가장 어두운 봄의 여왕", cardStage: 3 },
  { name: "구암신의", cardStage: 3 }
];

const tier2Backgrounds = [
  { name: "버려진 미로의 연인", cardStage: 2 },
  { name: "술과 황홀경의 신", cardStage: 2 },
  { name: "12월 25일의 주인", cardStage: 2 },
  { name: "하늘의 서기관", cardStage: 2 },
  { name: "고려제일검", cardStage: 2 },
  { name: "부유한 밤의 아버지", cardStage: 2 },
  { name: "매금지존", cardStage: 2 },
  { name: "오공원 두꺼비", cardStage: 2 },
  { name: "시조의 어머니", cardStage: 2 },
  { name: "이천일류의 달인", cardStage: 2 },
  { name: "절름발이 사기꾼", cardStage: 1 },
  { name: "여덟 머리의 군주", cardStage: 1 },
  { name: "잡배의 군주", cardStage: 1 },
  { name: "넉살 좋은 잡담꾼", cardStage: 1 },
  { name: "늙은 시계추의 관리자", cardStage: 1 },
  { name: "저주받은 검투사", cardStage: 1 },
  { name: "장막 뒤의 그림자", cardStage: 1 },
  { name: "외눈 미륵", cardStage: 1 },
  { name: "조선제일술사", cardStage: 1 },
  { name: "헌천홍도경문위무대왕", cardStage: 1 },
  { name: "양다리 전문가", cardStage: 1 },
  { name: "국정농단의 달인", cardStage: 1 }
];

// 배후성에 따른 카드 단계 반환 함수
const getCardStage = (background: string): number => {
  // 배후성이 '없음'인 경우 0단계
  if (background === '없음') {
    return 0;
  }
  
  // 1티어 배후성 확인
  const tier1Background = tier1Backgrounds.find(bg => bg.name === background);
  if (tier1Background) {
    return tier1Background.cardStage;
  }
  
  // 2티어 배후성 확인
  const tier2Background = tier2Backgrounds.find(bg => bg.name === background);
  if (tier2Background) {
    return tier2Background.cardStage;
  }
  
  // 기본값 (선택하지 않겠습니다 등)
  return 1;
};

// 카드 단계에 따른 텍스트 그림자 색상 반환 함수
const getTextShadowColor = (cardStage: number) => {
  switch (cardStage) {
    case 0:
      return '#6997FF'; // 파란색
    case 1:
      return '#6997FF'; // 하늘색
    case 2:
      return 'rgba(18, 71, 137, 0.8)'; // 파란색
    case 3:
      return 'rgba(181, 120, 6, 0.8)'; // 금색
    case 4:
      return 'rgba(24, 117, 121, 0.8)'; // 흰색
    case 5:
      return 'rgba(255,0,0,0.8)'; // 붉은색
    case 6:
      return 'rgba(128,0,128,0.8)'; // 보라색
    default:
      return 'rgba(255,255,255,0.8)'; // 기본 흰색
  }
};

// 배후성에 따른 계약서 이미지 반환 함수
const getContractImage = (background: string, cardStage: number) => {
  // cardStage 3인 경우 배후성별로 개별 이미지 반환
  if (cardStage === 3) {
    switch (background) {
      case "올림푸스":
        return contractOlympusImg;
      case "해상전신":
        return contractHaesangImg;
      case "강철의 주인":
        return contractGangcheolImg;
      case "악마같은 불의 심판자":
        return contractAkmaImg;
      case "무저갱의 지배자":
        return contractMujeogangImg;
      case "디펜스 마스터":
        return contractDefenseImg;
      case "구암신의":
        return contractGuamImg;
      case "가장 어두운 봄의 여왕":
        return contractSpringQueenImg;
      case "긴고아의 죄수":
        return contractGingoaImg;
      default:
        return contractLevel3Img; // 기본 cardStage 3 이미지
    }
  }
  
  // 다른 cardStage들은 기존 로직 유지
  switch (cardStage) {
    case 0:
      return contractLevel0Img;
    case 1:
      return contractLevel1Img;
    case 2:
      return contractLevel2Img;
    case 4:
      return contractLevel4Img;
    case 5:
      return contractLevel5Img;
    case 6:
      return contractLevel6Img;
    default:
      return contractLevel1Img;
  }
};

const FadeInDiv = styled.div.withConfig({
  shouldForwardProp: (prop) => !['visible'].includes(prop)
})<{ visible: boolean }>`
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 1.2s;
`;

const ContractPage = () => {
  const [bgVisible, setBgVisible] = useState(0);
  const [titleVisible, setTitleVisible] = useState(0);
  const [contractVisible, setContractVisible] = useState(0);
  const [showAfterContract, setShowAfterContract] = useState(false);
  
  // 이미지 로딩 상태
  const [isContractImageLoaded, setIsContractImageLoaded] = useState(false);
  const [isTitleImageLoaded, setIsTitleImageLoaded] = useState(false);
  
  // 아이폰 관련 상태
  const [showIosElements, setShowIosElements] = useState(false);
  const [capturedImageUrl, setCapturedImageUrl] = useState('');
  
  // 취소 확인 팝업 관련 상태
  const [showCancelPopup, setShowCancelPopup] = useState(false);

  // 계약 완료 시퀀스 관련 상태
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [showBluePopup, setShowBluePopup] = useState(false);
  const [hideContractElements, setHideContractElements] = useState(false);

  // 계약 저장 팝업 관련 상태
  const [showContractSavePopup, setShowContractSavePopup] = useState(false);
  const [compositeImageUrl, setCompositeImageUrl] = useState('');
  const [showSaveConfirmButton, setShowSaveConfirmButton] = useState(false);

  // location을 컴포넌트 최상위에서 호출
  const location = useLocation();

  // 로컬스토리지에서 사용자 정보 가져오기
  const [userData, setUserData] = useState<{
    nickname: string;
    background: string;
    avatarNumber: string;
  } | null>(null);
  
  // Firebase 에러 핸들링 훅
  const { errorState, handleFirebaseError, hideError } = useFirebaseError();

  useEffect(() => {
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      try {
        const parsedUserData = JSON.parse(currentUser);
        setUserData({
          nickname: parsedUserData.nickname || '',
          background: parsedUserData.background || '',
          avatarNumber: parsedUserData.avatarNumber || '00'
        });
      } catch (error) {
        console.error('사용자 데이터 파싱 오류:', error);
        // 파싱 오류 시 location.state 사용 (fallback)
        const { nickname, partner, avatarNumber } = location.state || { nickname: '', partner: '', avatarNumber: '00' };
        setUserData({
          nickname,
          background: partner,
          avatarNumber
        });
      }
    } else {
      // 로컬스토리지에 데이터가 없으면 location.state 사용 (fallback)
      const { nickname, partner, avatarNumber } = location.state || { nickname: '', partner: '', avatarNumber: '00' };
      setUserData({
        nickname,
        background: partner,
        avatarNumber
      });
    }
  }, [location.state]);

  // 2. 배후성에 따른 카드 단계와 계약서 이미지 결정
  const cardStage = userData ? getCardStage(userData.background) : 1;
  const contractImage = userData ? getContractImage(userData.background, cardStage) : contractLevel1Img;
  const textShadowColor = getTextShadowColor(cardStage);
  
  // 디버깅용 로그
  console.log('userData:', userData);
  console.log('cardStage:', cardStage);
  console.log('contractImage:', contractImage);

  // 3. descText 생성
  const descText = userData ? userData.background === '없음' 
    ? `[${userData.nickname}]은(는)\n배후를 선택하지 않겠습니다.`
    : `[${userData.nickname}]은(는)\n[${userData.background}]과(와)\n스트림 계약을 체결한다.`
    : '계약서를 불러오는 중...';

  const { navigateWithSession } = useSessionNavigation();

  // 아이폰 감지 함수
  const isIOS = () => {
    // return /iPad|iPhone|iPod/.test(navigator.userAgent) || 
    //        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    return true;
  };


  // 아이폰 확인 버튼 클릭
  const handleIosConfirm = () => {
    soundManager.playButtonClick();
    setShowIosElements(false);
    setCapturedImageUrl('');
  };

  // 합성 이미지 생성 함수 - 해상도 개선 버전
  const createCompositeImage = async (): Promise<string> => {
    const target = document.getElementById('contract-capture-area');
    if (!target) {
      console.error('contract-capture-area 요소를 찾을 수 없습니다.');
      return '';
    }

    console.log('계약서 이미지 캡처 시작...');
    console.log('User Agent:', navigator.userAgent);
    console.log('캡처 대상 요소:', target);
    console.log('캡처 대상 요소 크기:', target.offsetWidth, 'x', target.offsetHeight);
    
    // 안드로이드 감지
    const isAndroid = /Android/i.test(navigator.userAgent);
    console.log('Android 감지:', isAndroid);
    
    try {
      // 모든 이미지 로딩 대기 (더 강화된 버전)
      const images = target.querySelectorAll('img');
      console.log('발견된 이미지 개수:', images.length);
      
      const imagePromises = Array.from(images).map((img, index) => {
        return new Promise<void>((resolve) => {
          console.log(`이미지 ${index} 로딩 상태:`, {
            complete: img.complete,
            naturalWidth: img.naturalWidth,
            naturalHeight: img.naturalHeight,
            src: img.src
          });
          
          if (img.complete && img.naturalWidth > 0) {
            console.log(`이미지 ${index} 이미 로드됨`);
            resolve();
          } else {
            const timeoutId = setTimeout(() => {
              console.log(`이미지 ${index} 로딩 타임아웃`);
              resolve(); // 타임아웃되어도 진행
            }, 5000);
            
            img.onload = () => {
              clearTimeout(timeoutId);
              console.log(`이미지 ${index} 로드 완료`);
              resolve();
            };
            img.onerror = (error) => {
              clearTimeout(timeoutId);
              console.log(`이미지 ${index} 로드 실패:`, error);
              resolve(); // 에러가 나도 진행
            };
          }
        });
      });
      
      await Promise.all(imagePromises);
      console.log('모든 이미지 로딩 완료');
      
      // 추가 대기 시간 (렌더링 완료 보장)
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // 해상도 개선을 위한 높은 스케일 설정
      const highQualityScale = isAndroid ? 2.0 : 3.0; // 안드로이드 2배, iOS 3배 해상도
      
      // 고품질 캔버스 옵션
      const canvasOptions = {
        useCORS: true,
        backgroundColor: '#000000',
        allowTaint: true,
        scale: highQualityScale, // 해상도 대폭 향상
        logging: false,
        foreignObjectRendering: false,
        removeContainer: true,
        imageTimeout: 8000,
        width: target.offsetWidth,
        height: target.offsetHeight,
        onclone: (clonedDoc: Document) => {
          // 복제된 문서에서 스타일 조정
          const clonedTarget = clonedDoc.getElementById('contract-capture-area');
          if (clonedTarget) {
            clonedTarget.style.transform = 'none';
            clonedTarget.style.transition = 'none';
            // 고해상도 렌더링을 위한 추가 설정
            clonedTarget.style.imageRendering = 'high-quality';
            clonedTarget.style.imageRendering = '-webkit-optimize-contrast';
          }
        }
      };
      
      // 계약서 이미지 캡처 (고해상도)
      const contractCanvas = await html2canvas(target, canvasOptions);
      
      console.log('고해상도 계약서 캔버스 크기:', contractCanvas.width, 'x', contractCanvas.height);
      console.log('캔버스 데이터 URL 길이:', contractCanvas.toDataURL().length);
      
      // 캔버스가 비어있는지 확인
      const contractCtx = contractCanvas.getContext('2d');
      if (contractCtx) {
        const imageData = contractCtx.getImageData(0, 0, contractCanvas.width, contractCanvas.height);
        const hasContent = imageData.data.some((value, index) => {
          // 알파 채널이 아닌 픽셀 중에서 0이 아닌 값이 있는지 확인
          return index % 4 !== 3 && value !== 0;
        });
        console.log('캔버스에 콘텐츠가 있는지:', hasContent);
        
        if (!hasContent) {
          console.warn('캔버스가 비어있습니다. 대체 방법을 시도합니다.');
          throw new Error('Empty canvas detected');
        }
      }
      
      // 상단을 자르기 위한 새로운 캔버스 생성
      const croppedCanvas = document.createElement('canvas');
      const croppedCtx = croppedCanvas.getContext('2d');
      if (!croppedCtx) return '';

      // 고해상도 캔버스 설정
      const devicePixelRatio = window.devicePixelRatio || 1;
      croppedCanvas.width = contractCanvas.width;
      croppedCanvas.height = contractCanvas.height - Math.floor(contractCanvas.height * 0.05);
      
      // 고품질 렌더링 설정
      croppedCtx.imageSmoothingEnabled = true;
      croppedCtx.imageSmoothingQuality = 'high';
      
      // 자른 이미지를 새 캔버스에 그리기
      croppedCtx.drawImage(
        contractCanvas,
        0, Math.floor(contractCanvas.height * 0.05), // 원본에서 시작 위치 (x, y)
        contractCanvas.width, contractCanvas.height - Math.floor(contractCanvas.height * 0.05), // 원본에서 가져올 크기
        0, 0, // 새 캔버스에서 시작 위치
        contractCanvas.width, contractCanvas.height - Math.floor(contractCanvas.height * 0.05) // 새 캔버스에 그릴 크기
      );

      // 합성 이미지를 위한 새로운 캔버스 생성 (고해상도)
      const compositeCanvas = document.createElement('canvas');
      const compositeCtx = compositeCanvas.getContext('2d');
      if (!compositeCtx) return '';

      // 고해상도 합성 캔버스 설정
      const phoneHeight = window.innerHeight;
      const phoneWidth = window.innerWidth;
      const compositeScale = 2.0; // 합성 이미지도 2배 해상도
      
      compositeCanvas.width = phoneWidth * compositeScale;
      compositeCanvas.height = phoneHeight * compositeScale;
      
      // 고품질 렌더링 설정
      compositeCtx.imageSmoothingEnabled = true;
      compositeCtx.imageSmoothingQuality = 'high';
      compositeCtx.scale(compositeScale, compositeScale);

      // 검은색 배경 그리기
      compositeCtx.fillStyle = '#000000';
      compositeCtx.fillRect(0, 0, phoneWidth, phoneHeight);

      // 계약서 이미지를 중앙에 배치 (크기와 위치는 동일하게 유지)
      const scale = 0.9;
      const scaledWidth = (croppedCanvas.width / highQualityScale) * scale;
      const scaledHeight = (croppedCanvas.height / highQualityScale) * scale;
      const contractX = (phoneWidth - scaledWidth) / 2;
      const contractY = (phoneHeight - scaledHeight) / 2 - 50;
      
      // 고해상도 계약서 그리기
      compositeCtx.drawImage(
        croppedCanvas, 
        contractX, 
        contractY, 
        scaledWidth, 
        scaledHeight
      );
      console.log('고해상도 계약서 이미지 그리기 완료');

      // 로고 이미지 로드 및 그리기 (고품질)
      const logoImg = new Image();
      logoImg.crossOrigin = 'anonymous';
      
      return new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => {
          console.log('로고 이미지 로드 타임아웃, 계약서만 반환');
          const finalUrl = compositeCanvas.toDataURL('image/png', 1.0); // 최고 품질
          resolve(finalUrl);
        }, 10000);
        
        logoImg.onload = () => {
          clearTimeout(timeoutId);
          console.log('고해상도 로고 이미지 로드 완료');
          try {
            // 로고 크기 계산 (축소된 계약서 너비의 60% - 크기 유지)
            const logoWidth = scaledWidth * 0.6;
            const logoHeight = (logoImg.height / logoImg.width) * logoWidth;
            
            // 로고 위치 (축소된 계약서 하단 중앙 - 위치 유지)
            const logoX = (phoneWidth - logoWidth) / 2;
            const logoY = contractY + scaledHeight - 50;
            
            // 고품질 로고 그리기
            compositeCtx.drawImage(logoImg, logoX, logoY, logoWidth, logoHeight);
            console.log('고해상도 로고 이미지 그리기 완료');
            
            // 최고 품질로 최종 합성 이미지 URL 반환
            const finalUrl = compositeCanvas.toDataURL('image/png', 1.0);
            console.log('고해상도 합성 이미지 생성 완료, URL 길이:', finalUrl.length);
            resolve(finalUrl);
          } catch (error) {
            console.error('로고 그리기 중 오류:', error);
            const finalUrl = compositeCanvas.toDataURL('image/png', 1.0);
            resolve(finalUrl);
          }
        };
        
        logoImg.onerror = (error) => {
          clearTimeout(timeoutId);
          console.log('로고 이미지 로드 실패:', error);
          const finalUrl = compositeCanvas.toDataURL('image/png', 1.0);
          resolve(finalUrl);
        };
        
        console.log('고해상도 로고 이미지 로드 시작:', captureLogoImg);
        logoImg.src = captureLogoImg;
      });
    } catch (error) {
      console.error('합성 이미지 생성 중 오류 발생:', error);
      
      // 실패 시 대체 방법 시도 (여전히 고해상도)
      console.log('대체 방법 시도...');
      try {
        // 더 긴 대기 시간으로 재시도
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        const fallbackCanvas = await html2canvas(target, {
          useCORS: true,
          backgroundColor: '#000000',
          allowTaint: true,
          scale: 1.5, // 대체 방법도 1.5배 해상도
          logging: true,
          foreignObjectRendering: false,
          imageTimeout: 8000, // 타임아웃 증가
          width: target.offsetWidth,
          height: target.offsetHeight,
          onclone: (clonedDoc: Document) => {
            // 복제된 문서에서 스타일 강제 설정
            const clonedTarget = clonedDoc.getElementById('contract-capture-area');
            if (clonedTarget) {
              clonedTarget.style.opacity = '1';
              clonedTarget.style.visibility = 'visible';
              clonedTarget.style.display = 'block';
              clonedTarget.style.transform = 'none';
              clonedTarget.style.transition = 'none';
            }
          }
        });
        
        console.log('대체 방법으로 고해상도 캔버스 생성 성공');
        console.log('대체 캔버스 크기:', fallbackCanvas.width, 'x', fallbackCanvas.height);
        
        // 대체 캔버스도 콘텐츠 확인
        const fallbackCtx = fallbackCanvas.getContext('2d');
        if (fallbackCtx) {
          const fallbackImageData = fallbackCtx.getImageData(0, 0, fallbackCanvas.width, fallbackCanvas.height);
          const fallbackHasContent = fallbackImageData.data.some((value, index) => {
            return index % 4 !== 3 && value !== 0;
          });
          console.log('대체 캔버스에 콘텐츠가 있는지:', fallbackHasContent);
        }
        
        return fallbackCanvas.toDataURL('image/png', 1.0);
      } catch (fallbackError) {
        console.error('대체 방법도 실패:', fallbackError);
        
        // 최종 대체 방법: 단순한 캡처
        try {
          console.log('최종 대체 방법 시도...');
          const simpleCanvas = await html2canvas(target, {
            useCORS: true,
            backgroundColor: '#000000',
            allowTaint: true,
            scale: 1.0,
            logging: false,
            foreignObjectRendering: false,
            imageTimeout: 10000
          });
          
          console.log('최종 대체 방법 성공');
          return simpleCanvas.toDataURL('image/png', 0.8);
        } catch (simpleError) {
          console.error('최종 대체 방법도 실패:', simpleError);
        }
      }
      
      return '';
    }
  };

  // 취소 버튼 클릭 시 팝업 표시
  const handleCancelClick = () => {
    soundManager.playButtonClick();
    setShowCancelPopup(true);
  };

  // 취소 팝업에서 "아니오" 버튼 클릭
  const handleCancelPopupNo = () => {
    soundManager.playButtonClick();
    setShowCancelPopup(false);
  };

  // 취소 팝업에서 "네" 버튼 클릭
  const handleCancelPopupYes = () => {
    soundManager.playButtonClick();
    setShowCancelPopup(false);
    
    // 로컬스토리지 초기화
    localStorage.removeItem('currentUser');
    localStorage.removeItem('contractImage');
    console.log('계약 취소로 인한 로컬스토리지 초기화 완료');
    
    navigateWithSession('/register');
  };

  // 새로운 계약 저장 팝업 시퀀스
  const showContractSaveSequence = async () => {
    console.log('계약 저장 시퀀스 시작');
    
    // 캡처 전에 요소가 완전히 보이는지 확인
    const target = document.getElementById('contract-capture-area');
    if (target) {
      console.log('캡처 전 요소 상태:', {
        offsetWidth: target.offsetWidth,
        offsetHeight: target.offsetHeight,
        opacity: window.getComputedStyle(target).opacity,
        visibility: window.getComputedStyle(target).visibility,
        display: window.getComputedStyle(target).display
      });
    }
    
    // 먼저 합성 이미지 생성 (요소가 보이는 상태에서)
    const compositeUrl = await createCompositeImage();
    
    console.log('합성 이미지 생성 결과:', compositeUrl ? '성공' : '실패');
    console.log('생성된 이미지 URL 길이:', compositeUrl ? compositeUrl.length : 0);
    
    if (compositeUrl) {
      // 합성 이미지 생성 후 계약 관련 요소들 페이드아웃
      setHideContractElements(true);
      
      // 페이드아웃 완료 후 팝업 표시
      setTimeout(() => {
        setCompositeImageUrl(compositeUrl);
        setShowContractSavePopup(true);
        
        // 3초 후 확인 버튼 표시
        setTimeout(() => {
          setShowSaveConfirmButton(true);
        }, 3000);
      }, 800); // 계약 요소들 페이드아웃 시간
    } else {
      // 이미지 생성 실패 시 사용자에게 알림
      console.error('계약서 이미지 생성에 실패했습니다.');
      
      // 계약 관련 요소들 페이드아웃
      setHideContractElements(true);
      
      // 에러 메시지와 함께 팝업 표시
      setTimeout(() => {
        setCompositeImageUrl(''); // 빈 URL로 설정
        setShowContractSavePopup(true);
        
        // 3초 후 확인 버튼 표시
        setTimeout(() => {
          setShowSaveConfirmButton(true);
        }, 3000);
      }, 800);
    }
  };

  // 계약 저장 팝업에서 확인 버튼 클릭
  const handleContractSaveConfirm = async () => {
    soundManager.playButtonClick();
    
    // 합성 이미지를 로컬스토리지에 저장 (있는 경우에만)
    if (compositeImageUrl) {
      try {
        localStorage.setItem('contractImage', compositeImageUrl);
        console.log('계약서 이미지가 로컬스토리지에 저장되었습니다.');
      } catch (error) {
        console.error('로컬스토리지 저장 실패:', error);
      }
    } else {
      console.log('저장할 계약서 이미지가 없습니다.');
    }
    
    // 팝업 닫기 (compositeImageUrl을 먼저 초기화하지 않고 팝업을 먼저 닫음)
    setShowContractSavePopup(false);
    setShowSaveConfirmButton(false);
    
    // 팝업이 완전히 닫힌 후 compositeImageUrl 초기화
    setTimeout(() => {
      setCompositeImageUrl('');
    }, 500);
    
    // 기존 계약 완료 시퀀스 진행
    setTimeout(() => {
      setShowConfirmPopup(true);
      
      // 2.5초 후 팝업 페이드아웃
      setTimeout(() => {
        setShowConfirmPopup(false);
        
        // 배후성이 '없음'인 경우 바로 페이지 이동
        if (userData?.background === '없음') {
          setTimeout(() => {
            navigateWithSession('/channel-open');
          }, 500); // 페이드아웃 완료 후 이동
        } else {
          // 배후성이 있는 경우 BluePopup 표시
          setTimeout(() => {
            setShowBluePopup(true);
          }, 500); // 페이드아웃 완료 후 BluePopup 표시
        }
      }, 2500);
    }, 500);
  };

  // 메시지를 파이어베이스에 저장하는 함수
  const saveMessageToFirebase = async () => {
    if (!userData?.nickname || !userData?.background) return;
    
    try {
      // 새로운 시간 기반 컬렉션 구조를 사용하여 사용자 정보 가져오기
      const userInfo = await getUserFromTimeBasedCollection(userData.nickname, userData.avatarNumber);
      
      if (userInfo) {
        const { collectionName, docId } = userInfo;
        
        // 받은 메시지 생성
        const newMessage = {
          message: `당신을 바라봅니다.`,
          senderNickname: userData.background,
          receivedAt: Timestamp.now(),
          isSystemMessage: true
        };
        
        // receivedMessages 배열에 메시지 추가
        const userDocRef = doc(db, collectionName, docId);
        await updateDoc(userDocRef, {
          receivedMessages: arrayUnion(newMessage)
        });
        
      }
    } catch (error) {
      console.error('메시지 저장 중 오류 발생:', error);
      // Firebase 에러 팝업 표시
      handleFirebaseError(error, '메시지 저장 중 오류가 발생했습니다.');
    }
  };

  // BluePopup에서 확인 버튼 클릭
  const handleBluePopupConfirm = () => {
    soundManager.playButtonClick();
    setShowBluePopup(false);
    
    // 메시지를 파이어베이스에 저장
    saveMessageToFirebase();
    
    setTimeout(() => {
      navigateWithSession('/channel-open');
    }, 500); // BluePopup 닫힘 후 페이지 이동
  };

  // 이미지 터치 이벤트 처리 - 안드로이드 호환성 개선
  const handleImageTouch = (e: React.TouchEvent) => {
    // 갤럭시에서 의도치 않은 확대 방지
    if (e.touches.length > 1) {
      e.preventDefault(); // 멀티터치 방지
    }
  };

  const handleImageContextMenu = (e: React.MouseEvent) => {
    // 우클릭 메뉴는 허용 (저장 기능을 위해)
    // e.preventDefault() 제거하여 안드로이드에서도 저장 메뉴 표시
  };

  // 안드로이드에서 길게 누르기 이벤트 처리
  const handleImageLongPress = (e: React.TouchEvent) => {
    // 갤럭시에서 길게 누르기 시 저장 메뉴가 나타나도록 함
    // 단, 멀티터치는 방지
    if (e.touches.length > 1) {
      e.preventDefault();
    }
  };

  // 갤럭시에서 터치 시작 시 확대 방지
  const handleImageTouchStart = (e: React.TouchEvent) => {
    // 갤럭시에서 의도치 않은 확대 방지
    if (e.touches.length > 1) {
      e.preventDefault();
    }
  };

  // 터치 이벤트 방지 함수 - 개선된 버전
  const preventTouchMove = (e: TouchEvent) => {
    // 가로 스크롤만 방지하고 세로 스크롤은 허용
    if (e.touches.length === 1) {
      const touch = e.touches[0];
      const startX = touch.clientX;
      const startY = touch.clientY;
      
      const handleTouchMove = (moveEvent: Event) => {
        const touchEvent = moveEvent as TouchEvent;
        const moveTouch = touchEvent.touches[0];
        const deltaX = Math.abs(moveTouch.clientX - startX);
        const deltaY = Math.abs(moveTouch.clientY - startY);
        
        // 세로 스크롤을 더 확실히 보장하기 위해 조건을 완화
        // 가로 이동이 세로 이동보다 2배 이상 클 때만 방지
        // 그리고 가로 이동이 최소 20px 이상일 때만 방지
        if (deltaX > deltaY * 2 && deltaX > 20) {
          touchEvent.preventDefault();
        }
      };
      
      const handleTouchEnd = () => {
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);
      };
      
      document.addEventListener('touchmove', handleTouchMove, { passive: false });
      document.addEventListener('touchend', handleTouchEnd);
    }
  };

  // 아이폰 오버레이 표시/숨김 시 터치 이벤트 제어 - 스크롤 방지 코드 제거
  useEffect(() => {
    if (showIosElements) {
      // 가로 터치 이벤트만 방지
      document.addEventListener('touchstart', preventTouchMove, { passive: false });
      // body 스타일 조작 제거하여 스크롤 허용
    } else {
      // 터치 이벤트 복원
      document.removeEventListener('touchstart', preventTouchMove);
    }

    return () => {
      // 정리 함수에서도 이벤트 리스너 제거
      document.removeEventListener('touchstart', preventTouchMove);
    };
  }, [showIosElements]);

  // 배경 이미지 로딩 시작
  useEffect(() => {
    const raf = requestAnimationFrame(() => setBgVisible(1));
    return () => cancelAnimationFrame(raf);
  }, []);

  // 타이틀 이미지 로딩 완료 후 표시
  useEffect(() => {
    if (bgVisible && isTitleImageLoaded) {
      setTitleVisible(1);
    }
  }, [bgVisible, isTitleImageLoaded]);

  // 계약서 이미지 로딩 완료 후 표시
  useEffect(() => {
    if (titleVisible && isContractImageLoaded) {
      const timer = setTimeout(() => setContractVisible(1), 700);
      return () => clearTimeout(timer);
    }
  }, [titleVisible, isContractImageLoaded]);

  // 계약서 표시 후 버튼들 표시
  useEffect(() => {
    if (contractVisible) {
      const timer = setTimeout(() => setShowAfterContract(true), 800);
      return () => clearTimeout(timer);
    } else {
      setShowAfterContract(false);
    }
  }, [contractVisible]);

  return (
    <FadeInBackground visible={bgVisible}>
      <img 
        src={contractTitleImg} 
        alt="계약 타이틀" 
        style={{ width: '80dvw', maxWidth: '90dvw', marginTop: '5dvh', opacity: titleVisible, transition: 'opacity 1.2s' }}
        onLoad={() => setIsTitleImageLoaded(true)}
        onError={() => setIsTitleImageLoaded(true)} // 에러가 나도 진행
      />
      <div id="contract-capture-area" style={{ opacity: hideContractElements ? 0 : 1, transition: 'opacity 0.8s ease' }}>
        <ContractImageWrapper visible={contractVisible}>
          <ContractImg 
            src={contractImage} 
            alt="계약 본문" 
            style={{ width: '100%', height: '100%', display: 'block', objectFit: 'cover', borderRadius: '0.5dvw' }}
            onLoad={() => setIsContractImageLoaded(true)}
            onError={() => setIsContractImageLoaded(true)} // 에러가 나도 진행
          />
          {/* 날짜 오버레이 */}
          <OverlayText top={22.5} left={50} fontSize="2.5dvw" color="#fff" fontFamily="Orbitron" fontWeight="200" style={{textShadow: `0 2px 8px rgba(255, 255, 255, 0.05), 0 0 20px ${textShadowColor}, 0 0 40px ${textShadowColor}, 0 0 60px ${textShadowColor}, 0 0 80px ${textShadowColor}, 0 0 100px ${textShadowColor}`}}>
            {getToday()}
          </OverlayText>
          {/* 1. 설명 텍스트 */}
          <OverlayTextBox>
            <FittedText textShadowColor={textShadowColor}>
              {descText.split('\n').map((line, idx) => (
                <React.Fragment key={idx}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </FittedText>
          </OverlayTextBox>
                      {/* 우하단 텍스트들 - 세로 배치, 오른쪽 정렬 */}
            <OverlayText top={72} left={userData?.background && userData.background.length >= 7 ? 58 : 65} fontSize="unset" style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'flex-end', gap: '0.8dvw'}}>
             {/* 화신번호 */}
             <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', gap: '1.5dvw' }}>
               <span style={{ fontSize: '2.5dvw', fontWeight: 200, color: '#fff', textShadow: `0 2px 8px rgba(255, 255, 255, 0), 0 0 10px ${textShadowColor}, 0 0 10px ${textShadowColor}, 0 0 5px ${textShadowColor}, 0 0 0px ${textShadowColor}`, fontFamily: 'MapoDPP, sans-serif', marginTop: '0.5dvw' }}>화신번호</span>
               <span style={{ fontSize: '4dvw', fontWeight: 550, color: '#fff', textShadow: `0 2px 8px rgba(255, 255, 255, 0), 0 0 10px ${textShadowColor}, 0 0 10px ${textShadowColor}, 0 0 5px ${textShadowColor}, 0 0 0px ${textShadowColor}`, fontFamily: 'MapoDPP, sans-serif' }}>{userData?.avatarNumber}</span>
             </div>
             {/* 계약자 */}
             <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', gap: '1.5dvw' }}>
               <span style={{ fontSize: '2.5dvw', fontWeight: 200, color: '#fff', textShadow: `0 2px 8px rgba(255, 255, 255, 0.03), 0 0 10px ${textShadowColor}, 0 0 10px ${textShadowColor}, 0 0 5px ${textShadowColor}, 0 0 0px ${textShadowColor}`, fontFamily: 'MapoDPP, sans-serif', marginTop: '0.5dvw' }}>계약자</span>
               <span style={{ fontSize: '4dvw', fontWeight: 550, color: '#fff', textShadow: `0 2px 8px rgba(255, 255, 255, 0.04), 0 0 20px ${textShadowColor}, 0 0 10px ${textShadowColor}, 0 0 5px ${textShadowColor}, 0 0 0px ${textShadowColor}`, fontFamily: 'MapoDPP, sans-serif' }}>{userData?.nickname}</span>
             </div>
             {/* 배후성 - 디버깅을 위해 항상 표시 */}
             <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', gap: '1.5dvw' }}>
               <span style={{ fontSize: '2.5dvw', fontWeight: 200, color: '#fff', textShadow: `0 2px 8px rgba(255, 255, 255, 0.03), 0 0 20px ${textShadowColor}, 0 0 10px ${textShadowColor}, 0 0 5px ${textShadowColor}, 0 0 0px ${textShadowColor}`, fontFamily: 'MapoDPP, sans-serif', marginTop: '0.5dvw' }}>배후성</span>
               <span style={{ fontSize: '4dvw', fontWeight: 550, color: '#fff', textShadow: `0 2px 8px rgba(255, 255, 255, 0.01), 0 0 10px ${textShadowColor}, 0 0 10px ${textShadowColor}, 0 0 5px ${textShadowColor}, 0 0 0px ${textShadowColor}`, fontFamily: 'MapoDPP, sans-serif' }}>{userData?.background || '없음'}</span>
             </div>
           </OverlayText>
        </ContractImageWrapper>
      </div>
      
      <FadeInDiv visible={showAfterContract} style={{ opacity: hideContractElements ? 0 : 1, transition: 'opacity 0.8s ease' }}>
        {/* 계약체결 확인 텍스트 이미지 */}
        <img src={confirmTextImg} alt="계약체결 확인" style={{ width: '55dvw', maxWidth: 500, margin: '-5dvw auto 0 auto', display: 'block' }} />
        {/* 버튼들 */}
        <ButtonRow>
          <CancelButton src={cancelBtnImg} alt="취소" onClick={handleCancelClick} />
          <OkButton src={okBtnImg} alt="네" onClick={showContractSaveSequence} />
        </ButtonRow>
      </FadeInDiv>

                           {/* 아이폰용 오버레이 */}
       <IosOverlay visible={showIosElements}>
         <IosContainer>
           <CloseButton src={closeBtnImg} alt="닫기" onClick={handleIosConfirm} />
           {capturedImageUrl && (
             <CapturedImage src={capturedImageUrl} alt="캡처된 계약서" />
           )}
           <IosTextImage src={iosTextImg} alt="아이폰 설명" />
         </IosContainer>
       </IosOverlay>

       {/* 취소 확인 팝업 */}
       <CancelPopupOverlay visible={showCancelPopup}>
         <CancelPopupContainer>
           <CancelPopupImage src={cancelPopImg} alt="취소 확인" />
           <CancelPopupButtonRow>
             <CancelPopupNoButton src={cancelBtnImg2} alt="아니오" onClick={handleCancelPopupNo} />
             <CancelPopupYesButton src={registerOkBtnImg} alt="네" onClick={handleCancelPopupYes} />
           </CancelPopupButtonRow>
         </CancelPopupContainer>
       </CancelPopupOverlay>

       {/* 계약 저장 팝업 */}
       <ContractSavePopupOverlay visible={showContractSavePopup}>
         <ContractSavePopupContainer>
           <SavePopupTopText src={iosTextImg} alt="계약서 저장 안내" />
           {compositeImageUrl ? (
             <CompositeImage 
               src={compositeImageUrl} 
               alt="스타스트림 계약서" 
               crossOrigin="anonymous"
               onTouchStart={handleImageTouchStart}
               onTouchEnd={handleImageTouch}
               onTouchMove={handleImageLongPress}
               onTouchCancel={handleImageTouch}
               onContextMenu={handleImageContextMenu}
               onMouseDown={handleImageContextMenu}
               draggable={false}
               style={{ 
                 cursor: 'pointer',
                 userSelect: 'none',
                 WebkitUserSelect: 'none',
                 MozUserSelect: 'none',
                 msUserSelect: 'none',
                 WebkitTouchCallout: 'default',
                 KhtmlUserSelect: 'none',
                 touchAction: 'manipulation'
               } as React.CSSProperties}
             />
           ) : (
             <div style={{
               width: '80dvw',
               height: '60dvh',
               backgroundColor: '#000',
               border: '2px solid #fff',
               borderRadius: '1dvw',
               display: 'flex',
               flexDirection: 'column',
               alignItems: 'center',
               justifyContent: 'center',
               color: '#fff',
               fontSize: '4dvw',
               fontFamily: 'MapoDPP, sans-serif',
               textAlign: 'center',
               padding: '2dvw'
             }}>
               <div style={{ marginBottom: '2dvh' }}>
                 계약서 이미지를 생성할 수 없습니다.
               </div>
               <div style={{ fontSize: '3dvw', opacity: 0.8 }}>
                 계약은 정상적으로 완료되었습니다.
               </div>
             </div>
           )}
           <SaveConfirmButton 
             src={taleConfirmBtnImg} 
             alt="확인" 
             visible={showSaveConfirmButton}
             onClick={handleContractSaveConfirm}
           />
         </ContractSavePopupContainer>
       </ContractSavePopupOverlay>

       {/* 계약 완료 확인 팝업 */}
       <ConfirmPopupOverlay visible={showConfirmPopup}>
         <ConfirmPopupImage src={confirmPopImg} alt="계약 완료 확인" />
       </ConfirmPopupOverlay>

                               {/* BluePopup - 배후성이 있는 경우 */}
         {showBluePopup && (
           <ConfirmPopupOverlay visible={showBluePopup}>
             <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3dvh' }}>
               <BluePopup onClose={() => setShowBluePopup(false)}>
                 <div style={{ fontSize: '5.2dvw', fontFamily: 'MapoDPP, sans-serif', color: '#fff', textAlign: 'center', lineHeight: '1.4' }}>
                   [성좌, '{userData?.background}'<br />
                   이(가) 당신을 바라봅니다.]
                 </div>
               </BluePopup>
               <EndingOkButton 
                 src={endingPopOkImg} 
                 alt="확인" 
                 onClick={handleBluePopupConfirm}
               />
             </div>
           </ConfirmPopupOverlay>
         )}
         
         {/* Firebase 에러 팝업 */}
         <FirebaseErrorPopup
           isVisible={errorState.isError}
           onClose={hideError}
           message={errorState.errorMessage}
         />
    </FadeInBackground>
  );
};

export default withUrlValidation(ContractPage, {
  requireValidation: true,
  showCountdown: true
}); 